// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"3bb72446953d0e35","6831":"6261300e90732a81","8503":"7b854a2829742851","9683":"139884174e0ca63c"}[chunkId] + ".js";
};